import { render, staticRenderFns } from "./UploadScanAnimation.vue?vue&type=template&id=1ea93506&scoped=true"
import script from "./UploadScanAnimation.vue?vue&type=script&lang=ts"
export * from "./UploadScanAnimation.vue?vue&type=script&lang=ts"
import style0 from "./UploadScanAnimation.vue?vue&type=style&index=0&id=1ea93506&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea93506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea93506')) {
      api.createRecord('1ea93506', component.options)
    } else {
      api.reload('1ea93506', component.options)
    }
    module.hot.accept("./UploadScanAnimation.vue?vue&type=template&id=1ea93506&scoped=true", function () {
      api.rerender('1ea93506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/UploadScanAnimation.vue"
export default component.exports